var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDelete = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "18px",
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7A66D2F1-5107-489B-8CE9-84424BAC52FF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REIS-add-Transaction",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "REIS_Add-Transaction-(Disposition-Cost)-v2.0",
    transform: "translate(-1205.000000, -1841.000000)",
    stroke: "#757575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Action/Delete",
    transform: "translate(1206.000000, 1841.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 1.5,
    x: 6.25,
    y: 0.75,
    width: 4.5,
    height: 2.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.27428786,3.25 L15.7224363,3.25 L14.2735159,17.0781575 C14.2535099,17.2690901 14.1630198,17.4370508 14.0295366,17.5572782 C13.8960535,17.6775057 13.7195774,17.75 13.5275994,17.75 L3.30420294,17.75 C3.11052849,17.75 2.93278437,17.6762573 2.79898245,17.5543034 C2.66518053,17.4323495 2.5753208,17.2621843 2.55741512,17.0693393 L1.27428786,3.25 Z",
    id: "Combined-Shape",
    strokeWidth: 0.5,
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.77462212e-15,
    y1: 3,
    x2: 17,
    y2: 3,
    id: "Line",
    strokeLinecap: "square"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Delete.5c35e8c63819616708ce9437643c4484.svg";